<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="large" color="#f2f2f2" type="ball-clip-rotate-pulse">
</ngx-spinner>
<router-outlet></router-outlet>
